module.exports = __webpack_public_path__ + "img/logo-min.6f46d04f.png";